import { pct, overlaps } from "./utils";
import { DateTime } from "luxon";
import {
  CHART_DATE_FORMAT_MONTH,
  CHART_DATE_FORMAT_DATE_SHORT,
  CHART_DATE_FORMAT_YEAR_SHORT,
  CHART_DATE_FORMAT_MONTH_SHORT
} from "./constants";

let getDisplayName, getLineageColor, predictionMode;

export function initializeReadout(_getDisplayName, _getLineageColor, _predictionMode) {
  getDisplayName = _getDisplayName;
  getLineageColor = _getLineageColor;
  predictionMode = _predictionMode;
}

export function showWeekDataReadout(readoutContainer, data, xAxis, date, variant, lineage, isOtherBucket) {

  let container = readoutContainer;

  let readoutData = (predictionMode) ? data.weeklyPredictionData : data.weeklyData;
  let weekData = readoutData.find(d => d.date.toISODate() === date.toISODate());

  let isPrediction = weekData && weekData.isPrediction || false;

  if (weekData) {

    let weekIndex = readoutData.findIndex(d => d.date.toISODate() === date.toISODate());

    if (weekIndex < 2) {
      container.classList.toggle("first-columns", true);
    } else if (weekIndex >= readoutData.length - 2) {
      container.classList.toggle("last-columns", true);
    } else {
      container.classList.toggle("first-columns", false);
      container.classList.toggle("last-columns", false);
    }

    container.classList.toggle("fuzzy", weekData.uncertain || false);
    document.querySelector("#low-count").classList.toggle("fuzzy", weekData.uncertain || false);

    // Handle lineage/subvariant readout

    let lineageData = weekData[lineage];

    // console.log(lineageData);


    let color = getLineageColor(variant, lineage);

    //console.log(variant, lineage, color);

    let linColor = color.set('lab.l', '*0.6');
    if (color.get('lab.l') > 65) {
      linColor = linColor.set('lab.l', '32.5');
    }
    linColor = linColor.desaturate(0.075);

    let mainColor = linColor.darken(1.25);

    let subColor = linColor;

    let refColor = color.set('lab.l', '*0.8');

    container.style.color = mainColor;

    container.querySelectorAll(".readout-lineage").forEach(r => {
      r.style.color = linColor;
    });
    container.querySelectorAll(".readout-sub").forEach(r => {
      r.style.color = subColor;
    });
    container.querySelectorAll(".reference").forEach(r => {
      r.style.backgroundColor = refColor;
      r.style.opacity = 0.8;
    });


    let preciseDate = date.plus({'hours':84}); // half the week

    let xCoord = xAxis(preciseDate);
    container.style.left = `${ xCoord.toFixed(2) }%`;



    let subvariantLabel = getDisplayName(lineage);
    if (isOtherBucket) {
      let variantLabel = getDisplayName(variant);
      //groupedByVariants, groupedByVariantsOthers
      //console.log(data.groupedByVariantsOthers[variant]);

      let otherVariant = data.groupedByVariantsOthers[variant];
      if (otherVariant && otherVariant.length > 0) {
        subvariantLabel = `${ otherVariant.length.toLocaleString() } other ${ variantLabel } subvariants`;
      } else if (otherVariant) {
        subvariantLabel = `other ${ variantLabel } subvariant${ otherVariant.length > 1 ? "s" : ""}`;
      }


    }

    container.querySelector(".pct-element .readout-lineage .text").innerHTML = subvariantLabel;
    container.querySelector(".bar-element .readout-lineage .text").innerHTML = subvariantLabel;
    container.querySelector(".curve-element .readout-lineage .text").innerHTML = subvariantLabel;





    if (lineageData) {

      let readoutCountPlural = 's';
      let readoutCountVal = lineageData.num || 0;
      if (readoutCountVal === 1) {
        readoutCountPlural = '';
      }

      //console.log(variant, lineage, isOtherBucket);



      // Disable all existing variant- classes
      // container.classList.forEach(v => {
      //   if (v.match(/variant-/gi)) {
      //     container.classList.toggle(v, false);
      //   }
      // });



      if (isPrediction) {

        let lower = lineageData.lower;
        let upper = lineageData.upper;

        if (lower < 0) { lower = 0 }
        if (upper < 0) { upper = 0 }

        let decimals = 0;

        if ((upper - lower) < 0.01) {
          decimals = 1;
        } else if (upper - lower < 0.001) {
          decimals = 2;
        }

        let lower_str = pct(lineageData.lower, decimals, true, false, true);
        let upper_str = pct(lineageData.upper, decimals, true, false);

        container.querySelector(".pct-element .readout-percent").innerHTML = `<span>Modeled: ${ pct(lineageData.pct, 0, false, true) }</span>`;
        container.querySelector(".pct-element .readout-count").innerHTML = `<span>Range: ${ lower_str }-${ upper_str }`;
        container.querySelector(".pct-element").classList.toggle("modeled", true);

        container.querySelector(".bar-element .readout-percent").innerHTML = `<span>Modeled: ${ pct(lineageData.pct, 0, false, true) }</span>`;
        container.querySelector(".bar-element .readout-count").innerHTML = `<span>Range: ${ lower_str }-${ upper_str }`;
        container.querySelector(".bar-element").classList.toggle("modeled", true);

        container.querySelector(".curve-element .readout-percent").innerHTML = `<span>Modeled: ${ pct(lineageData.pct, 0, false, true) }</span>`;
        container.querySelector(".curve-element .readout-count").innerHTML = `<span>Range: ${ lower_str }-${ upper_str }`;
        container.querySelector(".curve-element").classList.toggle("modeled", true);

      } else {

        container.querySelector(".pct-element .readout-percent").innerHTML = `<span>${ pct(lineageData.pct, 0, false, true) }</span>`;
        container.querySelector(".pct-element .readout-count").innerHTML = `<span>${ readoutCountVal.toLocaleString() }</span> genome${  readoutCountPlural}`;
        container.querySelector(".pct-element").classList.toggle("modeled", false);

        container.querySelector(".bar-element .readout-percent").innerHTML = `<span>${ pct(lineageData.pct, 0, false, true) }</span>`;
        container.querySelector(".bar-element .readout-count").innerHTML = `<span>${ readoutCountVal.toLocaleString() }</span> genome${  readoutCountPlural}`;
        container.querySelector(".bar-element").classList.toggle("modeled", false);

        container.querySelector(".curve-element .readout-percent").innerHTML = `<span>${ pct(lineageData.pct, 0, false, true) }</span>`;
        container.querySelector(".curve-element .readout-count").innerHTML = `<span>${ readoutCountVal.toLocaleString() }</span> genome${  readoutCountPlural}`;
        container.querySelector(".curve-element").classList.toggle("modeled", false);

      }

    } else {

      // N/A case

      container.querySelector(".pct-element .readout-percent").innerHTML = ``;
      container.querySelector(".pct-element .readout-count").innerHTML = `Not available`;

      container.querySelector(".bar-element .readout-percent").innerHTML = `Not available`;
      container.querySelector(".bar-element .readout-count").innerHTML = ``;

      container.querySelector(".curve-element .readout-percent").innerHTML = ``;
      container.querySelector(".curve-element .readout-count").innerHTML = `Not available`;
      container.querySelector(".curve-element").classList.toggle("modeled", false);
    }

  }

}

export function showDayDataReadout(readoutContainer, data, xAxis, date, variant, lineage, isOtherBucket) {

  //let container = document.querySelector("#readout");
  let container = readoutContainer;

  let isPrediction = false;

  // let dayData = data.dailyData.find(d => d.date.toISODate() === date.toISODate());
  // if (!dayData) {
  //   dayData = data.dailyPredictionData.find(d => d.date.toISODate() === date.toISODate());
  //   isPrediction = true;
  // }

  let dayData = data.dailyPredictionData.find(d => d.date.toISODate() === date.toISODate());

  if (!data.dailyData.find(d => d.date.toISODate() === date.toISODate())) {
    isPrediction = true;
  }

  //console.log('weekReadout', weekData);

  if (dayData) {

    // let dayIndex = data.dailyData.findIndex(d => d.date.toISODate() === date.toISODate());
    // if (dayIndex < 0) {
    //   dayIndex = data.dailyPredictionData.findIndex(d => d.date.toISODate() === date.toISODate());
    // }

    let dayIndex = data.dailyPredictionData.findIndex(d => d.date.toISODate() === date.toISODate());

    if (dayIndex < 2) {
      container.classList.toggle("first-columns", true);
    } else if (dayIndex >= data.dailyData.length - 2) {
      container.classList.toggle("last-columns", true);
    } else {
      container.classList.toggle("first-columns", false);
      container.classList.toggle("last-columns", false);
    }

    container.classList.toggle("fuzzy", dayData.uncertain || false);
    document.querySelector("#low-count").classList.toggle("fuzzy", dayData.uncertain || false);

    let xCoord = xAxis(date);
    container.style.left = `${ xCoord.toFixed(2) }%`;

    //console.log(variant, lineage, isOtherBucket);

    let subvariantLabel = getDisplayName(lineage);
    if (isOtherBucket) {
      let variantLabel = getDisplayName(variant);
      //groupedByVariants, groupedByVariantsOthers
      //console.log(data.groupedByVariantsOthers[variant]);

      let otherVariant = data.groupedByVariantsOthers[variant];
      if (otherVariant && otherVariant.length > 0) {
        subvariantLabel = `${ otherVariant.length.toLocaleString() } other ${ variantLabel } subvariants`;
      } else if (otherVariant) {
        subvariantLabel = `other ${ variantLabel } subvariant${ otherVariant.length > 1 ? "s" : ""}`;
      }


    }


    let color = getLineageColor(variant, lineage);

    let linColor = color.set('lab.l', '*0.6');
    if (color.get('lab.l') > 65) {
      linColor = linColor.set('lab.l', '32.5');
    }
    linColor = linColor.desaturate(0.075);

    let mainColor = linColor.darken(1.25);

    let subColor = linColor;

    let refColor = color.set('lab.l', '*0.8');

    container.style.color = mainColor;

    container.querySelectorAll(".readout-lineage").forEach(r => {
      r.style.color = linColor;
    });
    container.querySelectorAll(".readout-sub").forEach(r => {
      r.style.color = subColor;
    });
    container.querySelectorAll(".reference").forEach(r => {
      r.style.backgroundColor = refColor;
      r.style.opacity = 0.8;
    });


    container.querySelector(".pct-element .readout-lineage .text").innerHTML = subvariantLabel;
    container.querySelector(".bar-element .readout-lineage .text").innerHTML = subvariantLabel;
    container.querySelector(".curve-element .readout-lineage .text").innerHTML = subvariantLabel;


    // Handle lineage/subvariant readout

    let lineageData = dayData[lineage];

    if (lineageData) {

      let readoutCountPlural = 's';
      let readoutCountVal = lineageData.num || 0;
      if (readoutCountVal === 1) {
        readoutCountPlural = '';
      }

      if (isPrediction) {

        let lower = lineageData.lower;
        let upper = lineageData.upper;

        if (lower < 0) { lower = 0 }
        if (upper < 0) { upper = 0 }

        let decimals = 0;

        if ((upper - lower) < 0.01) {
          decimals = 1;
        } else if (upper - lower < 0.001) {
          decimals = 2;
        }

        let lower_str = pct(lower, decimals, true, false, true);
        let upper_str = pct(upper, decimals, true, false);

        container.querySelector(".pct-element .readout-percent").innerHTML = `<span>${ pct(lineageData.pct, 0, false, true, true) }</span>%`;
        container.querySelector(".pct-element .readout-count").innerHTML = `<span>${ readoutCountVal.toLocaleString() }</span> genome${  readoutCountPlural}`;
        //container.querySelector(".pct-element .readout-count").innerHTML = `<span>${ pct(lineageData.lower, 0, false, true, true) }-${ pct(lineageData.upper, 0, false, true, true) }%</span>`;

        container.querySelector(".bar-element .readout-percent").innerHTML = `<span>${ pct(lineageData.pct, 0, false, true, true) }</span>%`;
        container.querySelector(".bar-element .readout-count").innerHTML = `<span>${ readoutCountVal.toLocaleString() }</span> genome${  readoutCountPlural}`;
        //container.querySelector(".bar-element .readout-count").innerHTML = `<span>${ pct(lineageData.lower, 0, false, true, true) }-${ pct(lineageData.upper, 0, false, true, true) }%</span>`;

        container.querySelector(".curve-element .readout-percent").innerHTML = `<span>Modeled: ${ pct(lineageData.pct, 0, false, true, true) }</span>%`;
        container.querySelector(".curve-element .readout-count").innerHTML = `<span>Range: ${ lower_str }-${ upper_str }`;
        container.querySelector(".curve-element").classList.toggle("modeled", true);

      } else {

        container.querySelector(".pct-element .readout-percent").innerHTML = `<span>${ pct(lineageData.pct, 0, false, true, true) }</span>%`;
        container.querySelector(".pct-element .readout-count").innerHTML = `<span>${ readoutCountVal.toLocaleString() }</span> genome${  readoutCountPlural}`;

        container.querySelector(".bar-element .readout-percent").innerHTML = `<span>${ pct(lineageData.pct, 0, false, true, true) }</span>%`;
        container.querySelector(".bar-element .readout-count").innerHTML = `<span>${ readoutCountVal.toLocaleString() }</span> genome${  readoutCountPlural}`;

        container.querySelector(".curve-element .readout-percent").innerHTML = `<span>${ pct(lineageData.pct, 0, false, true, true) }</span>%`;
        container.querySelector(".curve-element .readout-count").innerHTML = `<span>${ readoutCountVal.toLocaleString() }</span> genome${  readoutCountPlural}`;
        container.querySelector(".curve-element").classList.toggle("modeled", false);
      }

      //let preciseDate = date.plus({'hours':84}); // half the week


    } else {

      // N/A case

      container.querySelector(".pct-element .readout-percent").innerHTML = ``;
      container.querySelector(".pct-element .readout-count").innerHTML = `Not available`;

      container.querySelector(".bar-element .readout-percent").innerHTML = `Not available`;
      container.querySelector(".bar-element .readout-count").innerHTML = ``;

      container.querySelector(".curve-element .readout-percent").innerHTML = ``;
      container.querySelector(".curve-element .readout-count").innerHTML = `Not available`;
      container.querySelector(".curve-element").classList.toggle("modeled", false);

    }


  }

}

export function showSubvariantReadout(subvariantTotals, subvariants, sequencesTotal) {

  let container = document.querySelector("#readout-subvariant");
  container.classList.toggle("highlight", true);

  let subvariantAggregateTotals = {num:0, pct:0};

  subvariants.forEach(subvariant => {

    let subvariantData = subvariantTotals[subvariant];
    if (subvariantData) {
      subvariantAggregateTotals.num += subvariantData.num;
    }
  });

  subvariantAggregateTotals.pct = subvariantAggregateTotals.num / sequencesTotal;

  if (subvariantAggregateTotals) {

    let readoutCountPlural = 's';
    let readoutCountVal = subvariantAggregateTotals.num;
    if (readoutCountVal === 1) {
      readoutCountPlural = '';
    }

    container.querySelector(".pct-element .readout-percent").innerHTML = `<span>${ pct(subvariantAggregateTotals.pct, 0, false, true, true) }% of ${ sequencesTotal.toLocaleString() }<br />shown genomes</span>`;
    container.querySelector(".pct-element .readout-count").innerHTML = `<span>${ readoutCountVal.toLocaleString() }</span> genome${  readoutCountPlural}`;

    container.querySelector(".bar-element .readout-percent").innerHTML = `<span>${ pct(subvariantAggregateTotals.pct, 0, false, true, true) }% of ${ sequencesTotal.toLocaleString() }<br />shown genomes</span>`;
    container.querySelector(".bar-element .readout-count").innerHTML = `<span>${ readoutCountVal.toLocaleString() }</span> genome${  readoutCountPlural}`;

    container.querySelector(".curve-element .readout-percent").innerHTML = `<span>${ pct(subvariantAggregateTotals.pct, 0, false, true, true) }% of ${ sequencesTotal.toLocaleString() }<br />shown genomes</span>`;
    container.querySelector(".curve-element .readout-count").innerHTML = `<span>${ readoutCountVal.toLocaleString() }</span> genome${  readoutCountPlural}`;

  }

}

export function hideSubvariantReadout() {
  let container = document.querySelector("#readout-subvariant");
  container.classList.toggle("highlight", false);
}

export function showWeeklyDateReadout(data, xAxis, date, chartContainer, timeAxisContainer) {

  let container = timeAxisContainer.querySelector(".readout-date");

  let readoutData = (predictionMode) ? data.weeklyPredictionData : data.weeklyData;
  let weekData = readoutData.find(d => d.date.toISODate() === date.toISODate());

  let oneWeekLater = date.plus({'day':6});

  if (container && weekData) {

    let weekIndex = readoutData.findIndex(d => d.date.toISODate() === date.toISODate());

    if (weekIndex < 2) {
      container.classList.toggle("first-columns", true);
    } else if (weekIndex >= readoutData.length - 2) {
      container.classList.toggle("last-columns", true);
    } else {
      container.classList.toggle("first-columns", false);
      container.classList.toggle("last-columns", false);
    }

    container.classList.toggle("fuzzy", weekData.uncertain || false);

    let firstMonthLabel = date.toFormat(CHART_DATE_FORMAT_MONTH);
    if (firstMonthLabel.length > 4) {
      firstMonthLabel = `${date.toFormat(CHART_DATE_FORMAT_MONTH_SHORT)  }`;
    }
    let secondMonthLabel = oneWeekLater.toFormat(CHART_DATE_FORMAT_MONTH);
    if (secondMonthLabel.length > 4) {
      secondMonthLabel = `${oneWeekLater.toFormat(CHART_DATE_FORMAT_MONTH_SHORT)  }`;
    }

    if (date.toFormat(CHART_DATE_FORMAT_MONTH) === oneWeekLater.toFormat(CHART_DATE_FORMAT_MONTH)) {

      // container.innerHTML = `
      // <p>${ date.toFormat(CHART_DATE_FORMAT_MONTH) } ${ date.toFormat(CHART_DATE_FORMAT_DATE_SHORT) }-${ oneWeekLater.toFormat(CHART_DATE_FORMAT_DATE_SHORT) }</p>
      // <p>${ date.toFormat(CHART_DATE_FORMAT_YEAR_SHORT) }</p>
      // `;
      container.innerHTML = `
      <p>Week of</p>
      <p class="readout-date-range">${ date.toFormat(CHART_DATE_FORMAT_DATE_SHORT) }-${ oneWeekLater.toFormat(CHART_DATE_FORMAT_DATE_SHORT) } ${ firstMonthLabel }</p>
      `;

    } else {

      // Range spans 2 months
      // container.innerHTML = `
      // <p>${ date.toFormat(CHART_DATE_FORMAT_MONTH) } ${ date.toFormat(CHART_DATE_FORMAT_DATE_SHORT) } - ${ oneWeekLater.toFormat(CHART_DATE_FORMAT_MONTH) } ${ oneWeekLater.toFormat(CHART_DATE_FORMAT_DATE_SHORT) }</p>
      // <p>${ date.toFormat(CHART_DATE_FORMAT_YEAR_SHORT) }</p>
      // `;
      container.innerHTML = `
        <p>Week of</p>
        <p class="readout-date-range">${ date.toFormat(CHART_DATE_FORMAT_DATE_SHORT) } ${ firstMonthLabel } - ${ oneWeekLater.toFormat(CHART_DATE_FORMAT_DATE_SHORT) } ${ secondMonthLabel }</p>
        `;

    }

    let preciseDate = date.plus({'hours':84}); // half the week

    let xCoord = xAxis(preciseDate);
    container.style.left = `${ xCoord.toFixed(2) }%`;

    // Hide the other labels

    let allDateLabels = timeAxisContainer.querySelectorAll(".date");
    allDateLabels.forEach(label => {
      let dateLabel = label.getAttribute("data-date");
      if (dateLabel) {
        dateLabel = DateTime.fromISO(dateLabel);

        let diff = dateLabel.diff(date, 'weeks');

        let line = chartContainer.querySelector(`.date-lines .date-line[data-date="${ dateLabel.toISODate() }"]`);

        if (overlaps(label, container)) {
          label.classList.toggle("hide", true);
          if (line) {
            line.classList.toggle("hide", true);
          }
        } else {
          label.classList.toggle("hide", false);
          if (line) {
            line.classList.toggle("hide", false);
          }
        }
      }
    });

  }
}

export function showDailyDateReadout(data, xAxis, date, chartContainer, timeAxisContainer) {

  let container = timeAxisContainer.querySelector(".readout-date");

  let dailyData = data.dailyData.find(d => d.date.toISODate() === date.toISODate());
  if (!dailyData) {
    dailyData = data.dailyPredictionData.find(d => d.date.toISODate() === date.toISODate());
  }

  if (dailyData) {

    let dayIndex = data.dailyData.findIndex(d => d.date.toISODate() === date.toISODate());
    if (dayIndex < 0) {
      dayIndex = data.dailyPredictionData.findIndex(d => d.date.toISODate() === date.toISODate());
    }

    if (dayIndex < 2) {
      container.classList.toggle("first-columns", true);
    } else if (dayIndex >= data.weeklyData.length - 2) {
      container.classList.toggle("last-columns", true);
    } else {
      container.classList.toggle("first-columns", false);
      container.classList.toggle("last-columns", false);
    }

    container.classList.toggle("fuzzy", dailyData.uncertain || false);

    container.innerHTML = `
    <p>${ date.toFormat(CHART_DATE_FORMAT_DATE_SHORT) } ${ date.toFormat(CHART_DATE_FORMAT_MONTH) }</p>
    <p>${ date.toFormat(CHART_DATE_FORMAT_YEAR_SHORT) }</p>
    `;

    //let preciseDate = date.plus({'hours':84}); // half the week

    let xCoord = xAxis(date);
    container.style.left = `${ xCoord.toFixed(2) }%`;

    // Hide the other labels
    let allDateLabels = timeAxisContainer.querySelectorAll(".date");
    allDateLabels.forEach(label => {
      let dateLabel = label.getAttribute("data-date");
      if (dateLabel) {
        dateLabel = DateTime.fromISO(dateLabel);

        let diff = dateLabel.diff(date, 'weeks');

        let line = chartContainer.querySelector(`.date-lines .date-line[data-date="${ dateLabel.toISODate() }"]`);

        if (overlaps(label, container)) {
          label.classList.toggle("hide", true);
          if (line) {
            line.classList.toggle("hide", true);
          }
        } else {
          label.classList.toggle("hide", false);
          if (line) {
            line.classList.toggle("hide", false);
          }
        }
      }
    });

  }
}
